export const isArrayLength = arr => Array.isArray(arr) && !!arr.length

export const getSlug = name => name.replace(/\s+/g, "-").replace(/[^a-z0-9\-]/gmi, "").toLowerCase()